import { UseFormReturn } from "react-hook-form";

import Form from "../base/Form/Form";
import { Button } from "../base/Button";
import LoadingWheel from "../shared/LoadingWheel";
import { FormErrors } from "../base/Form/FormErrors";
import { FormSelect } from "../base/Form/FormSelect";
import Modal, { ModalControlProps } from "../../layouts/Modal";
import { enumToSelectOptions } from "../../utils/enumToKeyValue";
import useApplications from "../../data/Application/useApplications";
import useCustomerApplicationsMutations from "../../data/CustomerApplication/useCustomerApplicationMutations";
import {
  CustomerApplicationStatus,
  ICustomerApplication,
} from "../../models/CustomerApplication/CustomerApplication";
import { CreateUpdateCustomerApplicationFormFields } from "../../models/CustomerApplication/CreateUpdateCustomerApplication";

interface CreateUpdateApplicationModalProps extends ModalControlProps {
  customerId: string;
  application?: ICustomerApplication;
}

export function CreateUpdateApplicationModal({
  open,
  setOpen,
  customerId,
  application,
}: CreateUpdateApplicationModalProps) {
  const { create, update } = useCustomerApplicationsMutations(customerId);
  const { applications } = useApplications();

  const createApplication = (
    data: CreateUpdateCustomerApplicationFormFields
  ) => {
    create.mutate(
      { ...data, customerId, status: parseInt(data.status as any) },
      {
        onSuccess: () => {
          setOpen(false);
        },
      }
    );
  };

  const updateApplication = (
    data: CreateUpdateCustomerApplicationFormFields
  ) => {
    update.mutate(
      {
        ...data,
        customerId,
        id: application?.id,
      },
      {
        onSuccess: () => {
          setOpen(false);
        },
      }
    );
  };

  return (
    <Modal open={open} setOpen={setOpen} width="!w-1/3">
      <div>
        <div className="border-b">
          <h2 className="text-lg font-stick font-medium leading-6 mb-4 text-gray-900">
            Add Application
          </h2>
        </div>
        {applications.isLoading ? (
          <div className="flex items-center justify-center py-10">
            <LoadingWheel />
          </div>
        ) : (
          <Form<CreateUpdateCustomerApplicationFormFields>
            defaultValues={application ? application : {}}
            onSubmit={application ? updateApplication : createApplication}
            className="grid grid-cols-1 gap-y-4 md:grid-cols-2 md:gap-4"
          >
            {({
              register,
            }: UseFormReturn<CreateUpdateCustomerApplicationFormFields>) => (
              <>
                <div className="-m-4 md:col-span-2">
                  <FormErrors />
                </div>
                <div className="mb-4 grid grid-cols-1 gap-y-4 md:col-span-2">
                  <FormSelect
                    {...register("applicationId")}
                    label="Application"
                  >
                    {applications.data?.map((app) => (
                      <option value={app.id}>{app.name}</option>
                    ))}
                  </FormSelect>
                  <FormSelect {...register("status")} label="Status">
                    {enumToSelectOptions(CustomerApplicationStatus).map(
                      (status) => (
                        <option value={status.value}>{status.label}</option>
                      )
                    )}
                  </FormSelect>
                </div>
                <Button type="submit">Save</Button>
                <Button type="reset" variant="outlined">
                  Reset
                </Button>
              </>
            )}
          </Form>
        )}
      </div>
    </Modal>
  );
}
